import clockIcon from "../../../assets/clock.svg";
import dollarIcon from "../../../assets/dollar.svg";
import headphonesIcon from "../../../assets/headphones.svg";

export const information = [
  {
    icon: clockIcon,
    title: "Solve Problems Real Time",
    content:
      "Real-time problem solving is not just about time, it's about time. This allows you to solve within a specified time problem has a solution.",
  },
  {
    icon: dollarIcon,
    title: "Secured & Safe Payments",
    content:
      "By and large, credit cards are easily the most secure and safe payment method to use when you shop online. credit cards most secure.",
  },
  {
    icon: headphonesIcon,
    title: "24//7 Customer Support",
    content:
      "The biggest benefit of offering 24/7 support is that you provide a more convenient service for your customers providing clock support.",
  },
];
